import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplateTypes } from '@lbmx/per-form-primeng';
import { ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { HttpMethod, Request } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng-lts';
import { take } from 'rxjs/operators';
import { RegistrationToken } from 'src/app/dtos/registration/registration.dto';
import { apiUrls } from 'src/app/layouts/secure/url-config';
import { ConfigProvider } from 'src/app/provider/config-provider';
import { RegistrationService } from 'src/app/services/registration/registration.service';

@Component({
  selector: 'app-register-wizard',
  templateUrl: './register-wizard.component.html',
  providers: [ConfirmationService],
})
export class RegisterWizardComponent implements OnInit {
  public wizardConfig: Request;
  public wizardUrl = '';
  public templateTypes = TemplateTypes;
  public showRegistrationSuccess = false;
  public validToken;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrNotificationService,
    public translocoService: TranslocoService,
    private configPrv: ConfigProvider,
    private registrationSrv: RegistrationService
  ) {}

  public ngOnInit(): void {
    this.validateToken();
    this.wizardUrl = this.configPrv.AppSetting.uriBase.apiBaseUrl;
    this.wizardConfig = {
      endpoint: apiUrls.registrationWizard(),
      httpMethod: HttpMethod.POST,
    };
  }

  public submit(event) {
    this.showRegistrationSuccess = true;
  }

  public redirect() {
    // empty
  }

  public validateToken(): void {
    this.registrationSrv
      .validateRegistrationLink(this.buildValidateTokenRequest())
      .pipe(take(1))
      .subscribe(
        async (res) => {
          if (res !== null) {
            this.validToken = true;
          }
        },
        (err) => {
          this.validToken = false;
        }
      );
  }

  private buildValidateTokenRequest(): RegistrationToken {
    const request: RegistrationToken = new RegistrationToken();
    this.route.queryParams.subscribe((params) => {
      request.token = params.token;
    });

    return request;
  }
}
